import { administerPayout } from 'APIs/payouts/payouts';
import Message from 'Components/Message';
import Modal from 'Components/Modal/Modal';
import { Label } from 'Constants/styles';
import { FormEvent, MouseEvent, ReactElement, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import getErrorMessage from 'utils/getErrorMessage';

import { FormField, FormRow, TextInput } from './styles';

type Props = {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
};

const PayoutManualPayment = ({ showModal, setShowModal }: Props): ReactElement => {
  const { apiAprilBaseUri } = useSelector((state: ReduxStateType) => ({
    apiAprilBaseUri: state.apiAprilBaseUri,
  }));

  const [payoutId, setPayoutId] = useState<string>('');
  const [modalIsLoading, setModalIsLoading] = useState<boolean>(false);
  const [modalErrorMsg, setModalErrorMsg] = useState<string>('');

  const handleSubmit = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setModalErrorMsg('');

      try {
        if (payoutId) {
          const confirmed = window.confirm(`
            Are you sure you want to mark the payout ID "${payoutId}" as manually paid?`);
          if (!confirmed) {
            return;
          }
          setModalIsLoading(true);
          const payload = {
            RecordPayoutManualPayment: {},
          };
          await administerPayout(apiAprilBaseUri, payoutId, payload);
          setPayoutId('');
          setShowModal(false);
        }
      } catch (e) {
        setModalErrorMsg(getErrorMessage(e));
      } finally {
        setModalIsLoading(false);
      }
    },
    [apiAprilBaseUri, payoutId, setShowModal],
  );

  const handleCloseModalMsg = (e: MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    setModalErrorMsg('');
  };

  const handleCancel = (e: MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    setShowModal(false);
    setModalErrorMsg('');
    setPayoutId('');
  };

  return (
    <>
      {showModal && (
        <Modal
          title="Mark Payout as Paid"
          cancelBtnText="Cancel"
          confirmBtnText="Submit"
          handleCancel={handleCancel}
          handleSubmit={handleSubmit}
          disableConfirmBtn={modalIsLoading}
          isLoading={modalIsLoading}
          testId={'payout-manual-payment-modal'}
        >
          {modalErrorMsg.length > 0 && (
            <Message
              className="mt-2 mb-0"
              success={false}
              description={modalErrorMsg}
              handleClose={handleCloseModalMsg}
            />
          )}
          <div className="form">
            <FormRow>
              <Label>Payout ID</Label>
              <FormField>
                <TextInput
                  type="text"
                  name="payoutId"
                  placeholder="Eg. payout_xxxxxxxxxxxxxxxx"
                  value={payoutId}
                  required
                  onChange={(e) => setPayoutId(e.target.value)}
                  data-testid="payout-manual-payment-modal-payoutid-input"
                />
              </FormField>
            </FormRow>
          </div>
        </Modal>
      )}
    </>
  );
};

export default PayoutManualPayment;
